import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en.json';
import jp from './jp.json';
import hi from './hi.json';

// Seed the initial language SYNCHRONOUSLY from the persisted preference,
// BEFORE i18n.init runs. Previously `lng` was hardcoded 'en': on reload
// every t() string rendered English on first paint, then App.syncLanguage
// flipped i18next to the Redux language after mount — a visible flash
// (e.g. the footer "FAQ" link). Reading localStorage here — the same
// 'userLanguagePreference' key the dropdowns write and index.tsx's
// detectInitialLanguage reads — eliminates the flash for ALL strings.
function readInitialLanguage() {
  try {
    const saved = localStorage.getItem('userLanguagePreference');
    if (saved && ['en', 'hi', 'jp'].includes(saved)) {
      return saved;
    }
  } catch (e) {
    /* storage unavailable — fall through to the 'en' default */
  }
  return 'en';
}

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      jp: { translation: jp },
      hi: { translation: hi },
    },
    lng: readInitialLanguage(),
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
  });

// Boot-time language from the dxp_lang cookie. The landing site at
// nipponpolls.com sets it with domain=.nipponpolls.com, so panel.nipponpolls.com
// sees it on first arrival. Whitelist-only. Besides switching i18next, persist
// to the existing 'userLanguagePreference' key so index.tsx's
// detectInitialLanguage() picks it up as top priority — otherwise the
// Redux<->i18n sync would overwrite it.
function readLangCookie() {
  const m = document.cookie.match(/(?:^|;\s*)dxp_lang=([^;]+)/);
  return m ? m[1] : null;
}

const cookieLang = readLangCookie();
if (cookieLang && ['en', 'hi', 'jp'].includes(cookieLang)) {
  try { localStorage.setItem('userLanguagePreference', cookieLang); } catch (e) { /* storage unavailable — best-effort */ }
  i18n.changeLanguage(cookieLang);

  // One-time handoff — delete the cookie so it doesn't override later
  // dropdown choices on refresh.
  document.cookie = 'dxp_lang=; max-age=0; path=/; domain=.nipponpolls.com';
  document.cookie = 'dxp_lang=; max-age=0; path=/';
}

export default i18n;
